import { useState } from "react";
import { Download, Share, Plus } from "lucide-react";
import { useInstallPrompt } from "../hooks/usePWA";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";

// "Install app" button. Uses the native prompt on Android/Chromium; shows
// Add-to-Home-Screen instructions on iOS (which has no install event).
export default function InstallButton({ className = "" }) {
  const { canInstall, promptInstall, isIOS, isStandalone } = useInstallPrompt();
  const [showIOS, setShowIOS] = useState(false);

  if (isStandalone) return null;          // already installed
  if (!canInstall && !isIOS) return null; // browser can't offer install right now

  return (
    <>
      <Button
        data-testid="install-app-btn"
        variant="outline"
        onClick={() => (isIOS ? setShowIOS(true) : promptInstall())}
        className={`rounded-full border-indigo-200 text-indigo-700 hover:bg-indigo-50 gap-1.5 ${className}`}
      >
        <Download className="h-4 w-4" />
        <span className="hidden sm:inline">Install app</span>
      </Button>

      <Dialog open={showIOS} onOpenChange={setShowIOS}>
        <DialogContent className="max-w-sm" data-testid="ios-install-dialog">
          <DialogTitle className="font-display text-lg">Install Facio Doc</DialogTitle>
          <DialogDescription className="text-slate-600">
            Add Facio Doc to your Home Screen for a full-screen, app-like experience.
          </DialogDescription>
          <ol className="mt-2 space-y-3 text-sm text-slate-700">
            <li className="flex items-center gap-2">
              <span className="h-6 w-6 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold shrink-0">1</span>
              Tap the <Share className="h-4 w-4 inline text-indigo-600" /> <strong>Share</strong> button in Safari.
            </li>
            <li className="flex items-center gap-2">
              <span className="h-6 w-6 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold shrink-0">2</span>
              Choose <Plus className="h-4 w-4 inline text-indigo-600" /> <strong>Add to Home Screen</strong>.
            </li>
            <li className="flex items-center gap-2">
              <span className="h-6 w-6 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold shrink-0">3</span>
              Tap <strong>Add</strong> — that's it!
            </li>
          </ol>
          <Button className="mt-4 w-full rounded-full bg-indigo-600 hover:bg-indigo-700 text-white" onClick={() => setShowIOS(false)}>
            Got it
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
